import Box from '@mui/material/Box';

import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import {
    loadOnboardDevicesHardwareConfigurations,
    selectOnboardDevicesHardwareConfigurations,
} from '../store/onboardDeviceHardwareConfigurations.reducer';
import { OnboardDevicesHardwareConfigurationsTableGrid } from '../Components/OnboardDevicesHardwareConfigurationsTableGrid';

export const OnboardDevicesHardwareConfigurations = () => {
    const dispatch = useAppDispatch();
    const configurations = useAppSelector(selectOnboardDevicesHardwareConfigurations);

    useEffect(() => {
        dispatch(loadOnboardDevicesHardwareConfigurations());
    }, []);

    return (
        <Box sx={{ width: '100%', height: '100%', p: 2, boxSizing: 'border-box' }}>
            {configurations && (
                <OnboardDevicesHardwareConfigurationsTableGrid configurations={configurations} />
            )}
        </Box>
    );
};
